import {error} from "services-comun/modules/browser/log";

import {Controller} from "../controller";
import {EncuestasWebFrontendRequest} from "services-comun-ed/modules/services/encuestas/frontend-web";

export class EDGamesController extends Controller {
    /* STATIC */
    public static override async build(): Promise<void> {

        const form = document.querySelector(".ed-games-iframe") as HTMLIFrameElement|null;
        if (form!=null) {
            new this(form);
        }
    }

    /* INSTANCE */
    private constructor(private readonly form: HTMLIFrameElement) {
        super();


        const nombreJuego = document.location.hash?.length>0 ? document.location.hash.replace('#', '') : undefined;
        const params = new URLSearchParams(document.location.search);

        // UTM parameters
        const utmSource = params.get("utm_source")??"";
        const utmMedium = params.get("utm_medium")??"";
        const utmCampaign = params.get("utm_campaign")??"";

        const stringParams = `utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;

        // URL of the entry point
        const entryPointURL = new URL(`https://gamesnacks.com/embed/estadio/${nombreJuego && nombreJuego?.length>0?`games/${nombreJuego}`:''}?${stringParams}`);
        form.src = entryPointURL.toString();


    }
}
